module.exports = __webpack_public_path__ + "static/media/5_VP_Inez Wu min.90c06d23.jpg";